import useSWR from "swr";

export const useFetchLineAccountRegistrationsCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: lineAccountRegistrationsCount, error, isLoading } = useSWR<number>(`external_api/restaurants/${restaurantId}/line-accounts/registration-counts/?startDate=${startDate}&endDate=${endDate}`)
  return { lineAccountRegistrationsCount, isLoading, error };
};

